import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/app/App';
import { initPwa } from '@/pwa/installState';
import { registerServiceWorker } from '@/pwa/registerServiceWorker';
import { MissingEnvError, assertRequiredEnv } from '@/services/env';
import '@/styles/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Elemento #root não encontrado no index.html');
}

/**
 * Configuração ausente falha AQUI, com o nome da variável em tela — antes de montar o
 * React. Ver `services/env.ts` para o porquê.
 */
try {
  assertRequiredEnv();

  // Antes do React: o navegador oferece a instalação logo ao carregar a página.
  initPwa();
  registerServiceWorker();

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (error) {
  if (!(error instanceof MissingEnvError)) {
    throw error;
  }

  // Sem React: o erro é de configuração do build e a aplicação não deve subir. Texto por
  // `textContent` (nunca `innerHTML`) — a mensagem carrega nomes vindos do ambiente.
  const notice = document.createElement('p');
  notice.style.cssText = 'font: 16px/1.5 sans-serif; padding: 2rem; text-align: center';
  notice.textContent = error.message;
  container.replaceChildren(notice);

  throw error;
}
